'use client';

import { c as _c } from "react/compiler-runtime";
import { usePageAction } from '@cc-shopping/platform-analytics/hooks/usePageAction';
import { env } from '@cc-shopping/platform-env';
import { Button } from '@mui/material';
import { ENTRYPOINT_ENTITY_NAME, ENTRYPOINT_SECTION_NAME } from './constants';
import type { BranchButtonConfig } from './types';
type Props = {
  activityId: string;
  config: BranchButtonConfig;
  position: number;
};
export function BranchButton(t0) {
  const $ = _c(14);
  const {
    activityId,
    config,
    position
  } = t0;
  let t1;
  if ($[0] !== config.analyticsBranch) {
    t1 = {
      branch: config.analyticsBranch
    };
    $[0] = config.analyticsBranch;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== activityId || $[3] !== config.label || $[4] !== position || $[5] !== t1) {
    t2 = {
      actionName: ENTRYPOINT_ENTITY_NAME,
      actionType: "click",
      actionInput: config.label,
      actionSection: ENTRYPOINT_SECTION_NAME,
      impressionPosition: position,
      additionalAttributes: t1,
      parentActivityId: activityId
    };
    $[2] = activityId;
    $[3] = config.label;
    $[4] = position;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const firePageAction = usePageAction(t2);
  const t3 = `${env.NEXT_PUBLIC_NW_URL}/credit-cards/cardfinder/${config.branch}`;
  let t4;
  if ($[7] !== firePageAction) {
    t4 = () => firePageAction();
    $[7] = firePageAction;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      color: "common.white",
      borderColor: "rgba(255, 255, 255, 0.4)",
      borderRadius: 1,
      py: 1.5,
      px: 2,
      lineHeight: 1.5,
      fontWeight: 400,
      textTransform: "none",
      whiteSpace: "nowrap",
      "&:hover": {
        borderColor: "common.white",
        backgroundColor: "rgba(255, 255, 255, 0.08)"
      }
    };
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== config.label || $[11] !== t3 || $[12] !== t4) {
    t6 = <Button href={t3} onClick={t4} variant="outlined" component="a" fullWidth={false} sx={t5}>{config.label}</Button>;
    $[10] = config.label;
    $[11] = t3;
    $[12] = t4;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}